<template>
  <div class="container">
    <!-- Here We Load Our View -->

    <div class="app-container">
      <!-- Here We Load Nav Menu Bar -->
      <app-header></app-header>
      <transition name="fade" mode="out-in">
        <!--<keep-alive>-->
        <router-view></router-view>
        <!--</keep-alive>-->
      </transition>
      <!-- Here We Load Our Footer -->

    </div>
    <app-footer></app-footer>

  </div>
</template>

<script>
import AppHeader from './partials/AppHeader.vue'
import AppFooter from './partials/AppFooter.vue'
import Api from 'services/organization'
import {mapActions} from 'vuex'

export default {
  components: {
    AppHeader,
    AppFooter
  },
  methods: {
    ...mapActions([
      'toggleDevice',
      'toggleSidebar'
    ]),
    ...mapActions('organization', [
      'fetchScholarYears',
      'fetchSchools'
    ]),
    checkSchool() {
      if (this.$route.params.school === 'igpn') {
        this.$router.replace({'path': '/admissionsup/egpn/connexion'})
      }
      Api.showSchool(this.$route.params.school).then((result) => {
      }).catch(e => {
        if (this.$route.matched[0].meta.schoolType === 'boardingschool') {
          this.$router.push({name: 'boardingschool-not-found', params: {'0': this.$route.path}})
        }
        if (this.$route.matched[0].meta.schoolType === 'highschool') {
          this.$router.replace({name: 'highschool-not-found'})
        }

      })
    }
  },
  beforeMount() {
    const {body} = document
    const WIDTH = 768
    const RATIO = 3

    const handler = () => {
      if (!document.hidden) {
        const rect = body.getBoundingClientRect()
        const isMobile = rect.width - RATIO < WIDTH
        this.toggleDevice(isMobile ? 'mobile' : 'other')
        this.toggleSidebar({
          opened: !isMobile
        })
      }
    }

    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
    handler()
  },
  created: function () {
    if (this.$route.params.school) {
      this.checkSchool()
    }
    this.fetchSchools()
    this.fetchScholarYears()
  },
}
</script>
<style lang="scss">

.animated {
  animation-duration: .377s;
}

.modal {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: none;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  overflow: hidden;
  position: fixed;
  z-index: 10000;
}

</style>
